module.exports = __webpack_public_path__ + "static/media/iphone_db.ea5416fd.svg";